import type { IExtBookmark } from '@board/shared/model';

import { feathersFind } from '@board/hooks/useFeathersFind';
import { serviceNames } from '@board/shared/serviceNames';
import { useEffect } from 'react';

import { useExtBookmarkStore } from './store';

export const useBookmarksInit = () => {
  const setBookmarks = useExtBookmarkStore(s => s.set);
  useEffect(() => {
    feathersFind<IExtBookmark[], null>(serviceNames.extBookmarks, null).then(
      setBookmarks,
    );
  }, [setBookmarks]);
};
